<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="wrapper">

    <div class="container mb-5">
      <b-row class="justify-content-center">
        <b-col md="10">
          <b-card-group>
            <b-card no-body class="p-2">
              <b-card-body>
                <b-form>
                  <div class="text-center mb-2">
                    <img src="../../../../public/img/logo-mfu.png" height="200px"/>
                  </div>
                  <!--<h2>Login</h2>-->
                  <p class="text-muted text-center font-4xl">Course Withdraw Online</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="Username" autocomplete="username email" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Password" autocomplete="current-password" />
                  </b-input-group>

                  <p class="text-muted font-lg">Username / Password <br>use the same as the registration system</p>
                  <b-row>
                    <b-col cols="6" class="text-right">
                    </b-col >
                    <b-col cols="6">
                      <b-button variant="primary" class="w-100 text-white"  @click="onAUthen()">Login</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-mfu py-5 d-md-down-none" >
              <b-card-body>
                <div class="ql-editor" v-html="message"></div>
<!--                <div>-->

<!--                  <h3 class="text-center"> <b>Course Withdraw Online System</b> </h3>-->
<!--                  <h5 class="text-center" v-html="message"></h5>-->
<!--                  &lt;!&ndash;                  <h4 class="text-center"> First Semester 2023 </h4>&ndash;&gt;-->
<!--                  &lt;!&ndash;                  <h5 class="text-center"> Monday 16 Oct 2023 8.00 AM - Thursday 2 Nov 2023, 4:00 PM </h5>&ndash;&gt;-->


<!--                  <h4 class="mt-4 mb-4  text-center">System Manual</h4>-->
<!--                  <p class="text-white  text-center">-->
<!--                    <a class="text-white text-center " href="https://reg.mfu.ac.th/withdraw_test/manual/student.pdf" target="_blank"> <u>Student</u></a>-->
<!--                  </p>-->
<!--                  <p class="text-white  text-center">-->
<!--                    <a class="text-white text-center " href="https://reg.mfu.ac.th/withdraw_test/manual/instructor.pdf" target="_blank"> <u>Instructor</u></a>-->
<!--                  </p>-->
<!--                  <p class="text-white  text-center">-->
<!--                    <a class="text-white text-center " href="https://reg.mfu.ac.th/withdraw_test/manual/advisor.pdf" target="_blank"> <u>Advisor</u></a>-->
<!--                  </p>-->
<!--                  <p class="text-white  text-center">-->
<!--                    <a class="text-white text-center " href="https://reg.mfu.ac.th/withdraw_test/manual/dean.pdf" target="_blank"> <u>Dean</u></a>-->
<!--                  </p>-->

<!--                  <p> If you found any mistake or have any question, please contact division of registrar – registration section via</p>-->
<!--                  <p class="text-center"> Hotline registration section : 053-916369, 6370-72</p>-->
<!--                  <p class="text-center"> Email : registration.reg@mfu.ac.th</p>-->
<!--                </div>-->
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
    <div class="container ">
      <b-row class="justify-content-center">

        <b-col  cols="10">
          <b-card>
            <div slot="header" >
              <strong>Setting Login</strong>
            </div>


            <b-row>
              <b-col>
                <quill-editor  class="mb-3 mt-3 ql-editor" :content="message" @change="onEditor"/>
              </b-col>
            </b-row>
<!--            <b-row>-->
<!--              <b-col>-->
<!--                <b-form-group>-->
<!--                  <b-form-input type="text" class="form-control"  v-model="message" />-->
<!--                </b-form-group>-->
<!--              </b-col>-->
<!--            </b-row>-->

            <b-row>
              <b-col class="text-right">
                <b-button  variant="success" class=" text-white"  @click="onSubmit()">Submit</b-button>
              </b-col>
            </b-row>


          </b-card>
        </b-col>
      </b-row>

    </div>
  </div>
</template>

<script>
  import Service from "../../../service/api"
  import Vue from 'vue'
  import {mapGetters} from 'vuex'
  import VueQuillEditor from 'vue-quill-editor'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  Vue.use(VueQuillEditor)

  export default {
    components: {
      Service},
    name: 'Login',
    data () {
      return {
        state : false,
        stateDetail : false,
        disabled: false,
        message:""

      }
    },

    methods: {

      onInit(){
        Service.onGetMessagr().then((response) => {
          this.message = response.data.data[0].DESCRIPTION;
        }).catch((error) => {

        })
      },



      onSubmit(){
        var data = {};
        data.vmessagehome = this.message
        Service.onPutMessagr(data).then((response) => {

        }).catch((error) => {

        })
      },

      onEditor(html, text, quill) {
        this.message = html.html
      },

    },
    mounted() {


    },
    created () {
      this.onInit();
    },
  }


</script>
